export const promoActionsClick = {
  productCardMainPage: 1, // Клик по карточке продукта в ЛК на главной странице
  buttonShowMoreMainPage: 2, // Клик по кнопке "Показать еще" в ЛК на главной странице
  onlineLesson: 3, // Клик по рекламному онлайн-уроку
  modalOnlineLesson: 4, // Клик по целевой кнопке действия в модальном окне онлайн-урока
  ctpSubjects: 5, // Клик по рекламным материалам КТП (в предметах)
  ctpStatements: 6, // Клик по рекламным материалам КТП (в ведомости)
  modalCtp: 7, // Клик по целевой кнопке действия в модальном окне КТП
}
